'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.clearState = clearState;
exports.setWishlistButton = setWishlistButton;
exports.loadWishlists = loadWishlists;
exports.addWishlist = addWishlist;
exports.removeWishlist = removeWishlist;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _wishlist = require('utils/wishlist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_WISHLISTS = 'redux-frontend/wishlist/LOAD_WISHLISTS';
var LOAD_WISHLISTS_SUCCESS = 'redux-frontend/wishlist/LOAD_WISHLISTS_SUCCESS';
var LOAD_WISHLISTS_FAIL = 'redux-frontend/wishlist/LOAD_WISHLISTS_FAIL';

var ADD_WISHLIST = 'redux-frontend/wishlist/ADD_WISHLIST';
var ADD_WISHLIST_SUCCESS = 'redux-frontend/wishlist/ADD_WISHLIST_SUCCESS';
var ADD_WISHLIST_FAIL = 'redux-frontend/wishlist/ADD_WISHLIST_FAIL';

var REMOVE_WISHLIST = 'redux-frontend/wishlist/REMOVE_WISHLIST';
var REMOVE_WISHLIST_SUCCESS = 'redux-frontend/wishlist/REMOVE_WISHLIST_SUCCESS';
var REMOVE_WISHLIST_FAIL = 'redux-frontend/wishlist/REMOVE_WISHLIST_FAIL';

var SET_WISHLIST_BUTTON = 'redux-frontend/wishlist/SET_WISHLIST_BUTTON';

var CLEAR_STATE = 'redux-frontend/wishlist/CLEAR_STATE';

var LOAD_COMBINED_DYNAMIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_DYNAMIC_SUCCESS';

var initialState = {
  wishlistObj: {
    wishlists: [],
    isWishlisted: {}
  },
  error: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLEAR_STATE:
      return initialState;
    case LOAD_WISHLISTS:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_WISHLISTS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        wishlistObj: (0, _wishlist.mapWishlist)(action.result)
      });
    case LOAD_WISHLISTS_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    case LOAD_COMBINED_DYNAMIC_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        wishlistObj: (0, _wishlist.mapWishlist)(action.result.wishlist)
      });
    case SET_WISHLIST_BUTTON:
      var wishlistObj = _lodash2.default.cloneDeep(state.wishlistObj);
      wishlistObj.isWishlisted[action.tripId] = {
        loading: true,
        state: action.state
      };
      return (0, _extends3.default)({}, state, {
        wishlistObj: wishlistObj
      });
    default:
      return state;
  }
}

function clearState() {
  return {
    type: CLEAR_STATE
  };
}

function setWishlistButton(tripId, state) {
  return {
    type: SET_WISHLIST_BUTTON,
    tripId: tripId,
    state: state
  };
}

function loadWishlists() {
  return {
    types: [LOAD_WISHLISTS, LOAD_WISHLISTS_SUCCESS, LOAD_WISHLISTS_FAIL],
    promise: function promise(client) {
      return client.get('/users/me/wishlists');
    }
    // .then( (wishlists) => {
    //   const isWishlisted = {};
    //   wishlists.map( (item) => {
    //     isWishlisted[item._id] = {
    //       state: true,
    //       loading: false
    //     };
    //   });
    //   const obj = {
    //     wishlists,
    //     isWishlisted
    //   };
    //   return obj;
    // })
  };
}

function addWishlist(tripId) {
  return {
    types: [ADD_WISHLIST, ADD_WISHLIST_SUCCESS, ADD_WISHLIST_FAIL],
    promise: function promise(client) {
      return client.post('trips/' + tripId + '/wishlist');
    },
    tripId: tripId
  };
}

function removeWishlist(tripId) {
  return {
    types: [REMOVE_WISHLIST, REMOVE_WISHLIST_SUCCESS, REMOVE_WISHLIST_FAIL],
    promise: function promise(client) {
      return client.del('trips/' + tripId + '/wishlist');
    },
    tripId: tripId
  };
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, ADD_WISHLIST_SUCCESS, function (action) {
  return { name: 'Add Wishlist', category: 'Trip', trip_id: action.tripId };
}), (0, _defineProperty3.default)(_analytics, REMOVE_WISHLIST_SUCCESS, function (action) {
  return { name: 'Remove Wishlist', category: 'Trip', trip_id: action.tripId };
}), _analytics);


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/wishlist.js
// module id = 221
// module chunks = 47